import {useState} from 'react'
import {useQuery} from 'react-query'
import {fetchFleetReport} from './api'
import {PageTitle} from '../../../_metronic/layout/core'
import CRUDTable from '../../../components/table/CRUDTable'
import toast, {Toaster} from 'react-hot-toast'
import viewProps from '../viewProps'
import {Error500} from '../../modules/errors/components/Error500'
import TopBarProgress from 'react-topbar-progress-indicator'
import {Processing} from '../../../components/Loaders'
import {Helmet} from 'react-helmet'
import Select from 'react-select'
import {fetchShiftList} from '../shift/api'
import {FleetReportPayload} from './type'
import {fetchBusBrandList} from '../busBrand/api'
import ExportToExcelButton from './ExportToExcelButton'
import useSchool from '../../hooks/useSchools'


const FleetReport = () => {
  const [filters, setFilters] = useState<FleetReportPayload>({
    trip_type: 'all',
    shift_id: 'all',
    brand_name: 'all',
  })

  const {data: shift, isLoading: isLoadingShifts} = useQuery('shift', fetchShiftList)
  const {data: brand, isLoading: isLoadingBrands} = useQuery('brand', fetchBusBrandList)
 const { schoolName } = useSchool()
  const {
    data: reportData,
    isLoading: isLoadingReport,
    isFetching,
    isError,
    refetch,
  } = useQuery(
    'fleet-report',
    () =>
      fetchFleetReport({
        brand_name: filters.brand_name ?? '',
        trip_type: filters.trip_type ?? '',
        shift_id: filters.shift_id ?? '',
      }),
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  const handleApplyFilters = () => {
    const {brand_name, shift_id, trip_type} = filters

    if (!brand_name && !shift_id && (!trip_type || trip_type === 'all')) {
      toast.error('Please select at least one filter: Brand, Shift, or Trip Type.')
      return
    }

    toast.loading('Applying filters...')
    refetch()
      .then(() => {
        toast.dismiss()
        toast.success('Filters applied successfully.')
      })
      .catch(() => {
        toast.dismiss()
        toast.error('Failed to fetch fleet report.')
      })
  }

  if (isLoadingShifts || isLoadingBrands) {
    return <Processing />
  }

  const shiftOptions = [{shift_name: 'all', shift_id: 'all'}, ...shift?.data!].map((item: any) => ({
    label: item.shift_name.toUpperCase(),
    value: item.shift_id,
  }))

  const selectedShiftName =
    shift?.data.find((opt: any) => opt.shift_id === filters.shift_id)?.shift_name || 'All Shifts'

  console.log(reportData?.data)
  const brandOptions = [{bus_type: 'all'}, ...brand?.data!].map((item: any) => ({
    ...item,
    label: item.bus_type.toUpperCase(),
    value: item.bus_type,
  }))
  const selectedTripType =
    filters.trip_type === 'all'
      ? 'All Trip Types'
      : filters.trip_type.charAt(0).toUpperCase() + filters.trip_type.slice(1)

  return (
    <>
      <Helmet>
        <title>TrackNAB | Fleet Report</title>
      </Helmet>
      <PageTitle>Fleet Report</PageTitle>

      {/* Filters Section */}
      <div className="mb-4 p-4 border rounded shadow-sm bg-light">
        <div className="row g-3">
          <div className="col-md-2">
            <label className="form-label">Trip Type</label>
            <select
              className="form-select"
              value={filters.trip_type}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  trip_type: e.target.value as 'all' | 'pickup' | 'drop',
                })
              }
            >
              <option value="all">All</option>
              <option value="pickup">Pickup</option>
              <option value="drop">Drop</option>
            </select>
          </div>
          <div className="col-md-3">
            <label className="form-label">Brand</label>
            <Select
              options={brandOptions}
              onChange={(opt: any) => setFilters({...filters, brand_name: opt?.value || null})}
              value={brandOptions.find((opt) => opt.value === filters.brand_name) || null}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">Shift</label>
            <Select
              options={shiftOptions}
              onChange={(opt: any) => setFilters({...filters, shift_id: opt?.value || null})}
              value={shiftOptions.find((opt) => opt.value === filters.shift_id) || null}
            />
          </div>
          <div className="col-md-12 d-flex justify-content-end">
            <button className="btn btn-primary mt-2" onClick={handleApplyFilters}>
              Apply Filters
            </button>
          </div>
        </div>
      </div>

      {/* Table Section */}
      {isLoadingReport && <Processing />}
      {isError && <Error500 />}
      {reportData?.data?.length! > 0 ? (
        <CRUDTable
          data={reportData?.data}
          {...viewProps.FleetReport}
          fieldToLabelMap={viewProps.FleetReport.primaryFieldsToLabelMap}
          headerExtras={
            <>
              {/* <div className="fs-3">{`Mes School Security Fleet Report - ${selectedShiftName} - ${selectedTripType} - Year`}</div> */}
              <div className="ms-auto">
                <ExportToExcelButton
                  data={reportData?.data || []}
                  fileName="Fleet Report"
                  heading={`${schoolName} Security Fleet Report - ${selectedShiftName} - ${selectedTripType} - ${new Date().getFullYear()}`}
                  titleMap={viewProps.FleetReport.primaryFieldsToLabelMap}
                />
              </div>
            </>
          }
        />
      ) : (
        <div className="fs-2 p-6 text-center">Apply filters / No data for applied filters</div>
      )}

      {isFetching && <TopBarProgress />}
      <Toaster />
    </>
  )
}

export default FleetReport
